import { Suspense, type FC } from 'react';
import { Route } from 'react-router-dom';
import { useNotificationServicePublic } from 'src/apis/notification-service/use-notification-service-root';
import { ErrorBoundary } from 'src/components/feedback/error-boundary';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { useIsNewDesignActive } from 'src/pages/new-design/is-new-design';
import { NotificationsTabs } from 'src/pages/your-timeline-notifications/components/notifications-tabs';
import { NotificationDetails } from 'src/pages/your-timeline-notifications/details';
import { NotificationsOverview } from 'src/pages/your-timeline-notifications/overview';

export const NotificationsRoot: FC = () => {
  const isNewDesignActive = useIsNewDesignActive();

  if (isNewDesignActive) return <Notifications />;

  return (
    <>
      <NotificationsTabs />

      <ErrorBoundary>
        <Notifications />
      </ErrorBoundary>
    </>
  );
};

const Notifications: FC = () => {
  const notificationService = useNotificationServicePublic();

  if (!notificationService.response) {
    return <PageSpinner />;
  }

  return (
    <Suspense fallback={<PageSpinner />}>
      <RootRoutes>
        <Route
          path="/notifications"
          element={
            <NotificationsOverview notificationService={notificationService} />
          }
        />

        <Route
          path="/notifications/:notificationId"
          element={
            <NotificationDetails notificationService={notificationService} />
          }
        />

        <Route path="*" element={<ThrowNotFound />} />
      </RootRoutes>
    </Suspense>
  );
};
